export const SIGN_IN_USER = "SIGN_IN_USER";
export const SIGN_IN_TOKEN = "SIGN_IN_TOKEN";
export const SIGN_OUT_USER = "SIGN_OUT_USER";
export const UPDATE_USER_DISPLAY_SETTINGS = "UPDATE_USER_DISPLAY_SETTINGS";
